import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../hooks/auth';

export function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [pin, setPin] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!/^\d{6}$/.test(pin)) {
      setError('请输入 6 位 PIN');
      return;
    }
    setLoading(true);
    setError('');
    try {
      await login(pin);
      navigate('/dashboard');
    } catch (err) {
      setError('PIN 错误，请重试');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-left">
        <div className="logo">Bosamie</div>
        <div className="tagline">Myanmar Wholesale Platform</div>
        <div style={{ marginTop: 24, fontSize: 14, opacity: 0.7 }}>
          女士手袋批发管理系统
        </div>
      </div>
      <div className="login-right">
        <form className="login-card" onSubmit={handleSubmit}>
          <div className="title">Bosamie Myanmar · 管理后台</div>
          <div className="form-group">
            <label className="form-label">管理员 PIN</label>
            <input
              type="password"
              className="pin-input"
              maxLength={6}
              value={pin}
              onChange={(e) => setPin(e.target.value.replace(/\D/g, ''))}
              placeholder="••••••"
              autoFocus
            />
          </div>
          {error && <div className="error-msg">{error}</div>}
          <button type="submit" className="submit" disabled={loading}>
            {loading ? '验证中...' : '进入'}
          </button>
        </form>
      </div>
    </div>
  );
}
